import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import https from './utils/request'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import { getLocalStorage } from './utils/localStorage.js'

Vue.use(ElementUI);
Vue.config.productionTip = false
Vue.prototype.$http = https;

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!getLocalStorage()) {
      next({
        path: '/login',
        query: { redirect: to.fullPath }
      })
    } else {
      next()
    }
  } else {
    if (getLocalStorage()) {
      if (to.path === '/login') {
        next({ path: '/home' })
      } else {
        next()
      }
    } else {
      next() // 确保一定要调用 next()
    }
  }
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')